module.exports = __webpack_public_path__ + "static/media/broadband.bf93467b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/broadband.svg
// module id = 256
// module chunks = 0